import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import moment from 'moment'
import React from 'react'
import type { HeaderProps } from 'react-big-calendar'
import classnames from 'classnames'
import { useCalendar } from '../CalendarContext'
import { useIsMobile } from '@paintscout/ui'

const useStyles = makeStyles<Theme, { hideWeekends?: boolean }>((theme) => ({
  root: {
    ...theme.typography.body1,
    color: theme.paintscout.palette.brand.Neutral.P50,
    padding: theme.spacing(0.5),
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: ({ hideWeekends }) => (hideWeekends ? 'row' : 'column'),
      marginBottom: theme.spacing(1),
      padding: theme.spacing(0, 0.5)
    }
  },
  today: {
    border: `1px solid ${theme.paintscout.palette.primary}`,
    color: theme.paintscout.palette.primary,
    borderRadius: theme.borderRadius.md,
    [theme.breakpoints.down('xs')]: {
      fontWeight: 600
    }
  }
}))

export default function WeekColumnHeader(props: HeaderProps) {
  const { date } = props
  const { hideWeekends } = useCalendar()
  const mobile = useIsMobile({ xs: true })
  const classes = useStyles({ hideWeekends })

  const isWeekend = date.getDay() === 0 || date.getDay() === 6

  if (isWeekend && hideWeekends) {
    return null
  }

  const getFormattedDate = () => {
    if (mobile) {
      const day = moment(date).format('dd D')
      return (
        <>
          <span>{day.charAt(0).toUpperCase()}</span> <strong>{day.slice(2)}</strong>
        </>
      )
    }
    return moment(date).format('ddd D')
  }

  const isToday = moment(date).isSame(moment(), 'day')
  return <div className={classnames({ [classes.root]: true, [classes.today]: isToday })}>{getFormattedDate()}</div>
}
